module.exports = __webpack_public_path__ + "static/media/intro.5680285f.mp3";